import { render, staticRenderFns } from "./GlobalStatistics.vue?vue&type=template&id=a0da11f0"
import script from "./GlobalStatistics.vue?vue&type=script&lang=js"
export * from "./GlobalStatistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports